import {ReactElement, ReactNode} from 'react';
import {WhyDataRequired} from 'components/WhyDataRequired';
import {GroupTitle, Fields} from './styled';

type Props = {
  title: string;
  children: ReactElement | ReactElement[] | ReactNode | undefined;
  centered?: boolean;
  withWhyDataRequired?: boolean;
};
export const FieldsGroup = ({
  title,
  centered = true,
  children,
  withWhyDataRequired,
}: Props) => {
  return (
    <>
      <GroupTitle className="fields-group-title">
        <span>{title}</span> {withWhyDataRequired && <WhyDataRequired />}
      </GroupTitle>
      <Fields className="fields-group" $centered={centered}>
        {children}
      </Fields>
    </>
  );
};
